import script from "./DateComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./DateComponent.vue?vue&type=script&setup=true&lang=js"

import "./DateComponent.vue?vue&type=style&index=0&id=24b809de&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24b809de"]])

export default __exports__